<template>
  <div style="font-size: 18px; height: 100%; width: 100%">
    <div :gutter="20" v-for="n in 9" :key="n">
      <div class="row">
        <div @click="rowSelect(n - 1)" :class="getNDisabled(n)">
          <a href="#">
            <p
              :class="getNClass(n - 1)"
              :style="`padding: 10px; line-height: 13px;color:${
                n > zernikeSet.order + 1 ? 'rgba(255,255,255,0.3 )' : 'white'
              }`"
            >
              n = {{ n - 1 }}
            </p>
          </a>
        </div>
        <ZernikeIcon
          v-for="m in n"
          :key="m"
          :isFirstCol="m == 1"
          :index="calcIndex(n, m)"
          :zernikeVal="zernikeParams.params[calcIndex(n, m)].value"
          v-model="zernikeParams.params[calcIndex(n, m)].selected"
          :enabled="zernikeParams.params[calcIndex(n, m)].enabled"
        ></ZernikeIcon>
      </div>
    </div>
    <div class="mn-select">
      &nbsp;&nbsp;
      <div v-for="j in 17" :key="j" @click="colSelect(j - 9)">
        <a href="#">
          <p
            :class="getMClass(j - 9)"
            style="width: 45px; padding: 10px 1px 10px 1px; line-height: 20px"
          >
            m={{ j - 9 }}
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import ZernikeIcon from "./ZernikeIcon";
import IconButton from "./IconButton";
import { mapActions, mapGetters } from "vuex";
import EVENTS from "../../bus";

function _getMNLength(arr, key, cond) {
  return arr.filter((item) => {
    return item[key] === cond && item.selected && item.enabled;
  }).length;
}
function _getMNum(m) {
  return 9 - 4 - Math.ceil(Math.abs(m) / 2);
}
let timeoutLoading;
function clearTimeoutLoading() {
  if (timeoutLoading) {
    clearTimeout(timeoutLoading);
    timeoutLoading = null;
  }
}
export default {
  name: "ZernikePyramid",
  data() {
    return {};
  },
  components: {
    ZernikeIcon,
    IconButton
  },
  mounted() {},
  computed: {
    ...mapGetters(["zernikeParams", "zernikeSet"])
  },
  methods: {
    ...mapActions({
      zernikeParamsChanged: "topography/zernikeParamsChanged"
    }),
    showLoading() {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"));
      clearTimeout(timeoutLoading);
      timeoutLoading = setTimeout(() => {
        this.$bus.$emit(EVENTS.hideGlobalWatting);
      }, 5000);
    },
    calcIndex(n, m) {
      return ((n - 1) * n) / 2 + m - 1;
    },
    itemSelect(index, seled) {
      this.zernikeParams.params[index].selected = seled;
      this.zernikeParamsChanged(this.zernikeParams);
    },
    getNClass(n) {
      return _getMNLength(this.zernikeParams.params, "nIndex", n) === n + 1
        ? "selected"
        : "no-selected";
    },
    getNDisabled(n) {
      return n > this.zernikeSet.order + 1 ? "disabled" : "";
    },
    getMClass(m) {
      return _getMNLength(this.zernikeParams.params, "mIndex", m) === _getMNum(m)
        ? "selected"
        : "no-selected";
    },
    rowSelect(n) {
      let _state = !(_getMNLength(this.zernikeParams.params, "nIndex", n) === n + 1);
      for (let id in this.zernikeParams.params) {
        if (this.zernikeParams.params[id].nIndex === n) {
          this.zernikeParams.params[id].selected = _state;
        }
      }
      this.showLoading();
      this.zernikeParamsChanged(this.zernikeParams);
    },
    colSelect(m) {
      let _state = !(_getMNLength(this.zernikeParams.params, "mIndex", m) === _getMNum(m));
      for (let id in this.zernikeParams.params) {
        if (this.zernikeParams.params[id].mIndex === m) {
          this.zernikeParams.params[id].selected = _state;
        }
      }
      this.showLoading();
      this.zernikeParamsChanged(this.zernikeParams);
    }
  }
};
</script>
<style scoped>
.row {
  width: 100%;
  display: flex;
  justify-content: center;
}
.el-button {
  background: transparent;
  border: 1px solid gray;
  height: 30px;
}
.selected {
  border-left: 1px solid gray;
  border-top: 1px solid gray;
  border-right: 1px solid white;
  border-bottom: 1px solid white;
}
.no-selected {
  border: 1px solid gray;
}
a {
  text-decoration: none;
  color: white;
}
.disabled {
  pointer-events: none;
}
a:hover,
a:visited,
a:link,
a:active {
  color: white;
}
.mn-select {
  width: 100%;
  padding-top: 0px;
  padding-left: 20px;
  display: flex;
  margin-left: 174px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/ZernikePyramid.vue